import classNames from "classnames";
import { Col, Form } from "react-bootstrap";
import styles from "./FormSenderAddress.module.css";

const FormSenderAddress = ({ senderAddress, haghighi, hoghooghi }) => {
  return (
    <div key={senderAddress.id}>
      <section
        className={classNames(
          "w-100 d-flex flex-wrap justify-content-start",
          styles.section
        )}
      >
        <Col xxl={2} lg={3} md={4} sm={6} xs={12}>
          <Form.Label>
            نوع: <span className="text-danger">*</span>
          </Form.Label>
          <Form.Select
            className="select"
            name="type"
            defaultValue={senderAddress.type}
            disabled
          >
            <option value="0">حقیقی</option>
            <option value="1">حقوقی</option>
          </Form.Select>
        </Col>

        {haghighi ? (
          <Col xxl={2} lg={3} md={4} sm={6} xs={12}>
            <Form.Label>
              نام:<span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              defaultValue={senderAddress.name}
              disabled
            />
          </Col>
        ) : null}

        {haghighi ? (
          <Col xxl={2} lg={3} md={4} sm={6} xs={12}>
            <Form.Label>
              نام خانوادگی:
              <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              defaultValue={senderAddress.family}
              disabled
            />
          </Col>
        ) : null}

        {hoghooghi ? (
          <Col xxl={2} lg={3} md={4} sm={6} xs={12}>
            <Form.Label>
              نام شرکت:<span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              defaultValue={senderAddress.compony}
              disabled
            />
          </Col>
        ) : null}

        {hoghooghi ? (
          <Col xxl={2} lg={3} md={4} sm={6} xs={12}>
            <Form.Label>
              شناسه ملی: <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              name="shenase"
              defaultValue={senderAddress.shenase}
            />
          </Col>
        ) : null}

        {haghighi ? (
          <Col xxl={2} lg={3} md={4} sm={6} xs={12}>
            <Form.Label>
              کدملی:<span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              defaultValue={senderAddress.irCode}
              disabled
            />
          </Col>
        ) : null}

        <Col xxl={2} lg={3} md={4} sm={6} xs={12}>
          <Form.Label>
            موبایل:<span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            type="text"
            defaultValue={senderAddress.mobile}
            disabled
          />
        </Col>

        <Col xxl={2} lg={3} md={4} sm={6} xs={12}>
          <Form.Label> تلفن:</Form.Label>
          <Form.Control type="text" defaultValue={senderAddress.tel} disabled />
        </Col>

        <Col xxl={2} lg={3} md={4} sm={6} xs={12}>
          <Form.Label>
            استان:<span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            type="text"
            defaultValue={senderAddress.province}
            disabled
          />
        </Col>

        <Col xxl={2} lg={3} md={4} sm={6} xs={12}>
          <Form.Label>
            شهر:<span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            type="text"
            defaultValue={senderAddress.city}
            disabled
          />
        </Col>

        <Col xxl={2} lg={3} md={4} sm={6} xs={12}>
          <Form.Label>
            منطقه:<span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            type="text"
            defaultValue={senderAddress.area}
            disabled
          />
        </Col>

        <Col xxl={2} lg={3} md={4} sm={6} xs={12}>
          <Form.Label> کد پستی: </Form.Label>
          <Form.Control
            type="text"
            defaultValue={senderAddress.postCode}
            disabled
          />
        </Col>
      </section>

      <section>
        <Form.Label>
          آدرس:<span className="text-danger">*</span>
        </Form.Label>
        <Form.Control
          as="textarea"
          defaultValue={senderAddress.address}
          disabled
        />

        <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
      </section>
    </div>
  );
};

export default FormSenderAddress;
